export var Timezone;
(function (Timezone) {
    Timezone["Africa/Algiers"] = "Africa/Algiers";
    Timezone["Atlantic/Cape_Verde"] = "Atlantic/Cape_Verde";
    Timezone["Africa/Ndjamena"] = "Africa/Ndjamena";
    Timezone["Africa/Abidjan"] = "Africa/Abidjan";
    Timezone["Africa/Bamako"] = "Africa/Bamako";
    Timezone["Africa/Banjul"] = "Africa/Banjul";
    Timezone["Africa/Conakry"] = "Africa/Conakry";
    Timezone["Africa/Dakar"] = "Africa/Dakar";
    Timezone["Africa/Freetown"] = "Africa/Freetown";
    Timezone["Africa/Lome"] = "Africa/Lome";
    Timezone["Africa/Nouakchott"] = "Africa/Nouakchott";
    Timezone["Africa/Ouagadougou"] = "Africa/Ouagadougou";
    Timezone["Atlantic/St_Helena"] = "Atlantic/St_Helena";
    Timezone["Africa/Cairo"] = "Africa/Cairo";
    Timezone["Africa/Accra"] = "Africa/Accra";
    Timezone["Africa/Bissau"] = "Africa/Bissau";
    Timezone["Africa/Nairobi"] = "Africa/Nairobi";
    Timezone["Africa/Addis_Ababa"] = "Africa/Addis_Ababa";
    Timezone["Africa/Asmara"] = "Africa/Asmara";
    Timezone["Africa/Dar_es_Salaam"] = "Africa/Dar_es_Salaam";
    Timezone["Africa/Djibouti"] = "Africa/Djibouti";
    Timezone["Africa/Kampala"] = "Africa/Kampala";
    Timezone["Africa/Mogadishu"] = "Africa/Mogadishu";
    Timezone["Indian/Antananarivo"] = "Indian/Antananarivo";
    Timezone["Indian/Comoro"] = "Indian/Comoro";
    Timezone["Indian/Mayotte"] = "Indian/Mayotte";
    Timezone["Africa/Monrovia"] = "Africa/Monrovia";
    Timezone["Africa/Tripoli"] = "Africa/Tripoli";
    Timezone["Indian/Mauritius"] = "Indian/Mauritius";
    Timezone["Africa/Casablanca"] = "Africa/Casablanca";
    Timezone["Africa/El_Aaiun"] = "Africa/El_Aaiun";
    Timezone["Africa/Maputo"] = "Africa/Maputo";
    Timezone["Africa/Blantyre"] = "Africa/Blantyre";
    Timezone["Africa/Bujumbura"] = "Africa/Bujumbura";
    Timezone["Africa/Gaborone"] = "Africa/Gaborone";
    Timezone["Africa/Harare"] = "Africa/Harare";
    Timezone["Africa/Kigali"] = "Africa/Kigali";
    Timezone["Africa/Lubumbashi"] = "Africa/Lubumbashi";
    Timezone["Africa/Lusaka"] = "Africa/Lusaka";
    Timezone["Africa/Windhoek"] = "Africa/Windhoek";
    Timezone["Africa/Lagos"] = "Africa/Lagos";
    Timezone["Africa/Bangui"] = "Africa/Bangui";
    Timezone["Africa/Brazzaville"] = "Africa/Brazzaville";
    Timezone["Africa/Douala"] = "Africa/Douala";
    Timezone["Africa/Kinshasa"] = "Africa/Kinshasa";
    Timezone["Africa/Libreville"] = "Africa/Libreville";
    Timezone["Africa/Luanda"] = "Africa/Luanda";
    Timezone["Africa/Malabo"] = "Africa/Malabo";
    Timezone["Africa/Niamey"] = "Africa/Niamey";
    Timezone["Africa/Porto-Novo"] = "Africa/Porto-Novo";
    Timezone["Indian/Reunion"] = "Indian/Reunion";
    Timezone["Africa/Sao_Tome"] = "Africa/Sao_Tome";
    Timezone["Indian/Mahe"] = "Indian/Mahe";
    Timezone["Africa/Johannesburg"] = "Africa/Johannesburg";
    Timezone["Africa/Maseru"] = "Africa/Maseru";
    Timezone["Africa/Mbabane"] = "Africa/Mbabane";
    Timezone["Africa/Khartoum"] = "Africa/Khartoum";
    Timezone["Africa/Juba"] = "Africa/Juba";
    Timezone["Africa/Tunis"] = "Africa/Tunis";
    Timezone["Antarctica/Casey"] = "Antarctica/Casey";
    Timezone["Antarctica/Davis"] = "Antarctica/Davis";
    Timezone["Antarctica/Mawson"] = "Antarctica/Mawson";
    Timezone["Indian/Kerguelen"] = "Indian/Kerguelen";
    Timezone["Antarctica/DumontDUrville"] = "Antarctica/DumontDUrville";
    Timezone["Antarctica/Syowa"] = "Antarctica/Syowa";
    Timezone["Antarctica/Troll"] = "Antarctica/Troll";
    Timezone["Antarctica/Vostok"] = "Antarctica/Vostok";
    Timezone["Antarctica/Rothera"] = "Antarctica/Rothera";
    Timezone["Asia/Kabul"] = "Asia/Kabul";
    Timezone["Asia/Yerevan"] = "Asia/Yerevan";
    Timezone["Asia/Baku"] = "Asia/Baku";
    Timezone["Asia/Dhaka"] = "Asia/Dhaka";
    Timezone["Asia/Thimphu"] = "Asia/Thimphu";
    Timezone["Indian/Chagos"] = "Indian/Chagos";
    Timezone["Asia/Brunei"] = "Asia/Brunei";
    Timezone["Asia/Yangon"] = "Asia/Yangon";
    Timezone["Asia/Shanghai"] = "Asia/Shanghai";
    Timezone["Asia/Urumqi"] = "Asia/Urumqi";
    Timezone["Asia/Hong_Kong"] = "Asia/Hong_Kong";
    Timezone["Asia/Taipei"] = "Asia/Taipei";
    Timezone["Asia/Macau"] = "Asia/Macau";
    Timezone["Asia/Nicosia"] = "Asia/Nicosia";
    Timezone["Asia/Famagusta"] = "Asia/Famagusta";
    Timezone["Europe/Nicosia"] = "Europe/Nicosia";
    Timezone["Asia/Tbilisi"] = "Asia/Tbilisi";
    Timezone["Asia/Dili"] = "Asia/Dili";
    Timezone["Asia/Kolkata"] = "Asia/Kolkata";
    Timezone["Asia/Jakarta"] = "Asia/Jakarta";
    Timezone["Asia/Pontianak"] = "Asia/Pontianak";
    Timezone["Asia/Makassar"] = "Asia/Makassar";
    Timezone["Asia/Jayapura"] = "Asia/Jayapura";
    Timezone["Asia/Tehran"] = "Asia/Tehran";
    Timezone["Asia/Baghdad"] = "Asia/Baghdad";
    Timezone["Asia/Jerusalem"] = "Asia/Jerusalem";
    Timezone["Asia/Tokyo"] = "Asia/Tokyo";
    Timezone["Asia/Amman"] = "Asia/Amman";
    Timezone["Asia/Almaty"] = "Asia/Almaty";
    Timezone["Asia/Qyzylorda"] = "Asia/Qyzylorda";
    Timezone["Asia/Qostanay"] = "Asia/Qostanay";
    Timezone["Asia/Aqtobe"] = "Asia/Aqtobe";
    Timezone["Asia/Aqtau"] = "Asia/Aqtau";
    Timezone["Asia/Atyrau"] = "Asia/Atyrau";
    Timezone["Asia/Oral"] = "Asia/Oral";
    Timezone["Asia/Bishkek"] = "Asia/Bishkek";
    Timezone["Asia/Seoul"] = "Asia/Seoul";
    Timezone["Asia/Pyongyang"] = "Asia/Pyongyang";
    Timezone["Asia/Beirut"] = "Asia/Beirut";
    Timezone["Asia/Kuala_Lumpur"] = "Asia/Kuala_Lumpur";
    Timezone["Asia/Kuching"] = "Asia/Kuching";
    Timezone["Indian/Maldives"] = "Indian/Maldives";
    Timezone["Asia/Hovd"] = "Asia/Hovd";
    Timezone["Asia/Ulaanbaatar"] = "Asia/Ulaanbaatar";
    Timezone["Asia/Choibalsan"] = "Asia/Choibalsan";
    Timezone["Asia/Kathmandu"] = "Asia/Kathmandu";
    Timezone["Asia/Karachi"] = "Asia/Karachi";
    Timezone["Asia/Gaza"] = "Asia/Gaza";
    Timezone["Asia/Hebron"] = "Asia/Hebron";
    Timezone["Asia/Manila"] = "Asia/Manila";
    Timezone["Asia/Qatar"] = "Asia/Qatar";
    Timezone["Asia/Bahrain"] = "Asia/Bahrain";
    Timezone["Asia/Riyadh"] = "Asia/Riyadh";
    Timezone["Asia/Aden"] = "Asia/Aden";
    Timezone["Asia/Kuwait"] = "Asia/Kuwait";
    Timezone["Asia/Singapore"] = "Asia/Singapore";
    Timezone["Asia/Colombo"] = "Asia/Colombo";
    Timezone["Asia/Damascus"] = "Asia/Damascus";
    Timezone["Asia/Dushanbe"] = "Asia/Dushanbe";
    Timezone["Asia/Bangkok"] = "Asia/Bangkok";
    Timezone["Asia/Phnom_Penh"] = "Asia/Phnom_Penh";
    Timezone["Asia/Vientiane"] = "Asia/Vientiane";
    Timezone["Asia/Ashgabat"] = "Asia/Ashgabat";
    Timezone["Asia/Dubai"] = "Asia/Dubai";
    Timezone["Asia/Muscat"] = "Asia/Muscat";
    Timezone["Asia/Samarkand"] = "Asia/Samarkand";
    Timezone["Asia/Tashkent"] = "Asia/Tashkent";
    Timezone["Asia/Ho_Chi_Minh"] = "Asia/Ho_Chi_Minh";
    Timezone["Australia/Darwin"] = "Australia/Darwin";
    Timezone["Australia/Perth"] = "Australia/Perth";
    Timezone["Australia/Eucla"] = "Australia/Eucla";
    Timezone["Australia/Brisbane"] = "Australia/Brisbane";
    Timezone["Australia/Lindeman"] = "Australia/Lindeman";
    Timezone["Australia/Adelaide"] = "Australia/Adelaide";
    Timezone["Australia/Hobart"] = "Australia/Hobart";
    Timezone["Australia/Currie"] = "Australia/Currie";
    Timezone["Australia/Melbourne"] = "Australia/Melbourne";
    Timezone["Australia/Sydney"] = "Australia/Sydney";
    Timezone["Australia/Broken_Hill"] = "Australia/Broken_Hill";
    Timezone["Australia/Lord_Howe"] = "Australia/Lord_Howe";
    Timezone["Antarctica/Macquarie"] = "Antarctica/Macquarie";
    Timezone["Indian/Christmas"] = "Indian/Christmas";
    Timezone["Indian/Cocos"] = "Indian/Cocos";
    Timezone["Pacific/Fiji"] = "Pacific/Fiji";
    Timezone["Pacific/Gambier"] = "Pacific/Gambier";
    Timezone["Pacific/Marquesas"] = "Pacific/Marquesas";
    Timezone["Pacific/Tahiti"] = "Pacific/Tahiti";
    Timezone["Pacific/Guam"] = "Pacific/Guam";
    Timezone["Pacific/Saipan"] = "Pacific/Saipan";
    Timezone["Pacific/Tarawa"] = "Pacific/Tarawa";
    Timezone["Pacific/Enderbury"] = "Pacific/Enderbury";
    Timezone["Pacific/Kiritimati"] = "Pacific/Kiritimati";
    Timezone["Pacific/Majuro"] = "Pacific/Majuro";
    Timezone["Pacific/Kwajalein"] = "Pacific/Kwajalein";
    Timezone["Pacific/Chuuk"] = "Pacific/Chuuk";
    Timezone["Pacific/Pohnpei"] = "Pacific/Pohnpei";
    Timezone["Pacific/Kosrae"] = "Pacific/Kosrae";
    Timezone["Pacific/Nauru"] = "Pacific/Nauru";
    Timezone["Pacific/Noumea"] = "Pacific/Noumea";
    Timezone["Pacific/Auckland"] = "Pacific/Auckland";
    Timezone["Pacific/Chatham"] = "Pacific/Chatham";
    Timezone["Antarctica/McMurdo"] = "Antarctica/McMurdo";
    Timezone["Pacific/Rarotonga"] = "Pacific/Rarotonga";
    Timezone["Pacific/Niue"] = "Pacific/Niue";
    Timezone["Pacific/Norfolk"] = "Pacific/Norfolk";
    Timezone["Pacific/Palau"] = "Pacific/Palau";
    Timezone["Pacific/Port_Moresby"] = "Pacific/Port_Moresby";
    Timezone["Pacific/Bougainville"] = "Pacific/Bougainville";
    Timezone["Pacific/Pitcairn"] = "Pacific/Pitcairn";
    Timezone["Pacific/Pago_Pago"] = "Pacific/Pago_Pago";
    Timezone["Pacific/Midway"] = "Pacific/Midway";
    Timezone["Pacific/Apia"] = "Pacific/Apia";
    Timezone["Pacific/Guadalcanal"] = "Pacific/Guadalcanal";
    Timezone["Pacific/Fakaofo"] = "Pacific/Fakaofo";
    Timezone["Pacific/Tongatapu"] = "Pacific/Tongatapu";
    Timezone["Pacific/Funafuti"] = "Pacific/Funafuti";
    Timezone["Pacific/Wake"] = "Pacific/Wake";
    Timezone["Pacific/Efate"] = "Pacific/Efate";
    Timezone["Pacific/Wallis"] = "Pacific/Wallis";
    Timezone["Africa/Asmera"] = "Africa/Asmera";
    Timezone["Africa/Timbuktu"] = "Africa/Timbuktu";
    Timezone["America/Argentina/ComodRivadavia"] = "America/Argentina/ComodRivadavia";
    Timezone["America/Atka"] = "America/Atka";
    Timezone["America/Buenos_Aires"] = "America/Buenos_Aires";
    Timezone["America/Catamarca"] = "America/Catamarca";
    Timezone["America/Coral_Harbour"] = "America/Coral_Harbour";
    Timezone["America/Cordoba"] = "America/Cordoba";
    Timezone["America/Ensenada"] = "America/Ensenada";
    Timezone["America/Fort_Wayne"] = "America/Fort_Wayne";
    Timezone["America/Indianapolis"] = "America/Indianapolis";
    Timezone["America/Jujuy"] = "America/Jujuy";
    Timezone["America/Knox_IN"] = "America/Knox_IN";
    Timezone["America/Louisville"] = "America/Louisville";
    Timezone["America/Mendoza"] = "America/Mendoza";
    Timezone["America/Montreal"] = "America/Montreal";
    Timezone["America/Porto_Acre"] = "America/Porto_Acre";
    Timezone["America/Rosario"] = "America/Rosario";
    Timezone["America/Santa_Isabel"] = "America/Santa_Isabel";
    Timezone["America/Shiprock"] = "America/Shiprock";
    Timezone["America/Virgin"] = "America/Virgin";
    Timezone["Antarctica/South_Pole"] = "Antarctica/South_Pole";
    Timezone["Asia/Ashkhabad"] = "Asia/Ashkhabad";
    Timezone["Asia/Calcutta"] = "Asia/Calcutta";
    Timezone["Asia/Chongqing"] = "Asia/Chongqing";
    Timezone["Asia/Chungking"] = "Asia/Chungking";
    Timezone["Asia/Dacca"] = "Asia/Dacca";
    Timezone["Asia/Harbin"] = "Asia/Harbin";
    Timezone["Asia/Kashgar"] = "Asia/Kashgar";
    Timezone["Asia/Katmandu"] = "Asia/Katmandu";
    Timezone["Asia/Macao"] = "Asia/Macao";
    Timezone["Asia/Rangoon"] = "Asia/Rangoon";
    Timezone["Asia/Saigon"] = "Asia/Saigon";
    Timezone["Asia/Tel_Aviv"] = "Asia/Tel_Aviv";
    Timezone["Asia/Thimbu"] = "Asia/Thimbu";
    Timezone["Asia/Ujung_Pandang"] = "Asia/Ujung_Pandang";
    Timezone["Asia/Ulan_Bator"] = "Asia/Ulan_Bator";
    Timezone["Atlantic/Faeroe"] = "Atlantic/Faeroe";
    Timezone["Atlantic/Jan_Mayen"] = "Atlantic/Jan_Mayen";
    Timezone["Australia/ACT"] = "Australia/ACT";
    Timezone["Australia/Canberra"] = "Australia/Canberra";
    Timezone["Australia/LHI"] = "Australia/LHI";
    Timezone["Australia/NSW"] = "Australia/NSW";
    Timezone["Australia/North"] = "Australia/North";
    Timezone["Australia/Queensland"] = "Australia/Queensland";
    Timezone["Australia/South"] = "Australia/South";
    Timezone["Australia/Tasmania"] = "Australia/Tasmania";
    Timezone["Australia/Victoria"] = "Australia/Victoria";
    Timezone["Australia/West"] = "Australia/West";
    Timezone["Australia/Yancowinna"] = "Australia/Yancowinna";
    Timezone["Brazil/Acre"] = "Brazil/Acre";
    Timezone["Brazil/DeNoronha"] = "Brazil/DeNoronha";
    Timezone["Brazil/East"] = "Brazil/East";
    Timezone["Brazil/West"] = "Brazil/West";
    Timezone["Canada/Atlantic"] = "Canada/Atlantic";
    Timezone["Canada/Central"] = "Canada/Central";
    Timezone["Canada/Eastern"] = "Canada/Eastern";
    Timezone["Canada/Mountain"] = "Canada/Mountain";
    Timezone["Canada/Newfoundland"] = "Canada/Newfoundland";
    Timezone["Canada/Pacific"] = "Canada/Pacific";
    Timezone["Canada/Saskatchewan"] = "Canada/Saskatchewan";
    Timezone["Canada/Yukon"] = "Canada/Yukon";
    Timezone["Chile/Continental"] = "Chile/Continental";
    Timezone["Chile/EasterIsland"] = "Chile/EasterIsland";
    Timezone["Cuba"] = "Cuba";
    Timezone["Egypt"] = "Egypt";
    Timezone["Eire"] = "Eire";
    Timezone["Etc/UCT"] = "Etc/UCT";
    Timezone["Europe/Belfast"] = "Europe/Belfast";
    Timezone["Europe/Tiraspol"] = "Europe/Tiraspol";
    Timezone["GB"] = "GB";
    Timezone["GB-Eire"] = "GB-Eire";
    Timezone["GMT+0"] = "GMT+0";
    Timezone["GMT-0"] = "GMT-0";
    Timezone["GMT0"] = "GMT0";
    Timezone["Greenwich"] = "Greenwich";
    Timezone["Hongkong"] = "Hongkong";
    Timezone["Iceland"] = "Iceland";
    Timezone["Iran"] = "Iran";
    Timezone["Israel"] = "Israel";
    Timezone["Jamaica"] = "Jamaica";
    Timezone["Japan"] = "Japan";
    Timezone["Kwajalein"] = "Kwajalein";
    Timezone["Libya"] = "Libya";
    Timezone["Mexico/BajaNorte"] = "Mexico/BajaNorte";
    Timezone["Mexico/BajaSur"] = "Mexico/BajaSur";
    Timezone["Mexico/General"] = "Mexico/General";
    Timezone["NZ"] = "NZ";
    Timezone["NZ-CHAT"] = "NZ-CHAT";
    Timezone["Navajo"] = "Navajo";
    Timezone["PRC"] = "PRC";
    Timezone["Pacific/Johnston"] = "Pacific/Johnston";
    Timezone["Pacific/Ponape"] = "Pacific/Ponape";
    Timezone["Pacific/Samoa"] = "Pacific/Samoa";
    Timezone["Pacific/Truk"] = "Pacific/Truk";
    Timezone["Pacific/Yap"] = "Pacific/Yap";
    Timezone["Poland"] = "Poland";
    Timezone["Portugal"] = "Portugal";
    Timezone["ROC"] = "ROC";
    Timezone["ROK"] = "ROK";
    Timezone["Singapore"] = "Singapore";
    Timezone["Turkey"] = "Turkey";
    Timezone["UCT"] = "UCT";
    Timezone["US/Alaska"] = "US/Alaska";
    Timezone["US/Aleutian"] = "US/Aleutian";
    Timezone["US/Arizona"] = "US/Arizona";
    Timezone["US/Central"] = "US/Central";
    Timezone["US/East-Indiana"] = "US/East-Indiana";
    Timezone["US/Eastern"] = "US/Eastern";
    Timezone["US/Hawaii"] = "US/Hawaii";
    Timezone["US/Indiana-Starke"] = "US/Indiana-Starke";
    Timezone["US/Michigan"] = "US/Michigan";
    Timezone["US/Mountain"] = "US/Mountain";
    Timezone["US/Pacific"] = "US/Pacific";
    Timezone["US/Samoa"] = "US/Samoa";
    Timezone["UTC"] = "UTC";
    Timezone["Universal"] = "Universal";
    Timezone["W-SU"] = "W-SU";
    Timezone["Zulu"] = "Zulu";
    Timezone["Etc/GMT"] = "Etc/GMT";
    Timezone["Etc/UTC"] = "Etc/UTC";
    Timezone["GMT"] = "GMT";
    Timezone["Etc/Universal"] = "Etc/Universal";
    Timezone["Etc/Zulu"] = "Etc/Zulu";
    Timezone["Etc/Greenwich"] = "Etc/Greenwich";
    Timezone["Etc/GMT-0"] = "Etc/GMT-0";
    Timezone["Etc/GMT+0"] = "Etc/GMT+0";
    Timezone["Etc/GMT0"] = "Etc/GMT0";
    Timezone["Etc/GMT-14"] = "Etc/GMT-14";
    Timezone["Etc/GMT-13"] = "Etc/GMT-13";
    Timezone["Etc/GMT-12"] = "Etc/GMT-12";
    Timezone["Etc/GMT-11"] = "Etc/GMT-11";
    Timezone["Etc/GMT-10"] = "Etc/GMT-10";
    Timezone["Etc/GMT-9"] = "Etc/GMT-9";
    Timezone["Etc/GMT-8"] = "Etc/GMT-8";
    Timezone["Etc/GMT-7"] = "Etc/GMT-7";
    Timezone["Etc/GMT-6"] = "Etc/GMT-6";
    Timezone["Etc/GMT-5"] = "Etc/GMT-5";
    Timezone["Etc/GMT-4"] = "Etc/GMT-4";
    Timezone["Etc/GMT-3"] = "Etc/GMT-3";
    Timezone["Etc/GMT-2"] = "Etc/GMT-2";
    Timezone["Etc/GMT-1"] = "Etc/GMT-1";
    Timezone["Etc/GMT+1"] = "Etc/GMT+1";
    Timezone["Etc/GMT+2"] = "Etc/GMT+2";
    Timezone["Etc/GMT+3"] = "Etc/GMT+3";
    Timezone["Etc/GMT+4"] = "Etc/GMT+4";
    Timezone["Etc/GMT+5"] = "Etc/GMT+5";
    Timezone["Etc/GMT+6"] = "Etc/GMT+6";
    Timezone["Etc/GMT+7"] = "Etc/GMT+7";
    Timezone["Etc/GMT+8"] = "Etc/GMT+8";
    Timezone["Etc/GMT+9"] = "Etc/GMT+9";
    Timezone["Etc/GMT+10"] = "Etc/GMT+10";
    Timezone["Etc/GMT+11"] = "Etc/GMT+11";
    Timezone["Etc/GMT+12"] = "Etc/GMT+12";
    Timezone["Europe/London"] = "Europe/London";
    Timezone["Europe/Jersey"] = "Europe/Jersey";
    Timezone["Europe/Guernsey"] = "Europe/Guernsey";
    Timezone["Europe/Isle_of_Man"] = "Europe/Isle_of_Man";
    Timezone["Europe/Dublin"] = "Europe/Dublin";
    Timezone["WET"] = "WET";
    Timezone["CET"] = "CET";
    Timezone["MET"] = "MET";
    Timezone["EET"] = "EET";
    Timezone["Europe/Tirane"] = "Europe/Tirane";
    Timezone["Europe/Andorra"] = "Europe/Andorra";
    Timezone["Europe/Vienna"] = "Europe/Vienna";
    Timezone["Europe/Minsk"] = "Europe/Minsk";
    Timezone["Europe/Brussels"] = "Europe/Brussels";
    Timezone["Europe/Sofia"] = "Europe/Sofia";
    Timezone["Europe/Prague"] = "Europe/Prague";
    Timezone["Europe/Copenhagen"] = "Europe/Copenhagen";
    Timezone["Atlantic/Faroe"] = "Atlantic/Faroe";
    Timezone["America/Danmarkshavn"] = "America/Danmarkshavn";
    Timezone["America/Scoresbysund"] = "America/Scoresbysund";
    Timezone["America/Godthab"] = "America/Godthab";
    Timezone["America/Thule"] = "America/Thule";
    Timezone["Europe/Tallinn"] = "Europe/Tallinn";
    Timezone["Europe/Helsinki"] = "Europe/Helsinki";
    Timezone["Europe/Mariehamn"] = "Europe/Mariehamn";
    Timezone["Europe/Paris"] = "Europe/Paris";
    Timezone["Europe/Berlin"] = "Europe/Berlin";
    Timezone["Europe/Busingen"] = "Europe/Busingen";
    Timezone["Europe/Gibraltar"] = "Europe/Gibraltar";
    Timezone["Europe/Athens"] = "Europe/Athens";
    Timezone["Europe/Budapest"] = "Europe/Budapest";
    Timezone["Atlantic/Reykjavik"] = "Atlantic/Reykjavik";
    Timezone["Europe/Rome"] = "Europe/Rome";
    Timezone["Europe/Vatican"] = "Europe/Vatican";
    Timezone["Europe/San_Marino"] = "Europe/San_Marino";
    Timezone["Europe/Riga"] = "Europe/Riga";
    Timezone["Europe/Vaduz"] = "Europe/Vaduz";
    Timezone["Europe/Vilnius"] = "Europe/Vilnius";
    Timezone["Europe/Luxembourg"] = "Europe/Luxembourg";
    Timezone["Europe/Malta"] = "Europe/Malta";
    Timezone["Europe/Chisinau"] = "Europe/Chisinau";
    Timezone["Europe/Monaco"] = "Europe/Monaco";
    Timezone["Europe/Amsterdam"] = "Europe/Amsterdam";
    Timezone["Europe/Oslo"] = "Europe/Oslo";
    Timezone["Arctic/Longyearbyen"] = "Arctic/Longyearbyen";
    Timezone["Europe/Warsaw"] = "Europe/Warsaw";
    Timezone["Europe/Lisbon"] = "Europe/Lisbon";
    Timezone["Atlantic/Azores"] = "Atlantic/Azores";
    Timezone["Atlantic/Madeira"] = "Atlantic/Madeira";
    Timezone["Europe/Bucharest"] = "Europe/Bucharest";
    Timezone["Europe/Kaliningrad"] = "Europe/Kaliningrad";
    Timezone["Europe/Moscow"] = "Europe/Moscow";
    Timezone["Europe/Simferopol"] = "Europe/Simferopol";
    Timezone["Europe/Astrakhan"] = "Europe/Astrakhan";
    Timezone["Europe/Volgograd"] = "Europe/Volgograd";
    Timezone["Europe/Saratov"] = "Europe/Saratov";
    Timezone["Europe/Kirov"] = "Europe/Kirov";
    Timezone["Europe/Samara"] = "Europe/Samara";
    Timezone["Europe/Ulyanovsk"] = "Europe/Ulyanovsk";
    Timezone["Asia/Yekaterinburg"] = "Asia/Yekaterinburg";
    Timezone["Asia/Omsk"] = "Asia/Omsk";
    Timezone["Asia/Barnaul"] = "Asia/Barnaul";
    Timezone["Asia/Novosibirsk"] = "Asia/Novosibirsk";
    Timezone["Asia/Tomsk"] = "Asia/Tomsk";
    Timezone["Asia/Novokuznetsk"] = "Asia/Novokuznetsk";
    Timezone["Asia/Krasnoyarsk"] = "Asia/Krasnoyarsk";
    Timezone["Asia/Irkutsk"] = "Asia/Irkutsk";
    Timezone["Asia/Chita"] = "Asia/Chita";
    Timezone["Asia/Yakutsk"] = "Asia/Yakutsk";
    Timezone["Asia/Vladivostok"] = "Asia/Vladivostok";
    Timezone["Asia/Khandyga"] = "Asia/Khandyga";
    Timezone["Asia/Sakhalin"] = "Asia/Sakhalin";
    Timezone["Asia/Magadan"] = "Asia/Magadan";
    Timezone["Asia/Srednekolymsk"] = "Asia/Srednekolymsk";
    Timezone["Asia/Ust-Nera"] = "Asia/Ust-Nera";
    Timezone["Asia/Kamchatka"] = "Asia/Kamchatka";
    Timezone["Asia/Anadyr"] = "Asia/Anadyr";
    Timezone["Europe/Belgrade"] = "Europe/Belgrade";
    Timezone["Europe/Ljubljana"] = "Europe/Ljubljana";
    Timezone["Europe/Podgorica"] = "Europe/Podgorica";
    Timezone["Europe/Sarajevo"] = "Europe/Sarajevo";
    Timezone["Europe/Skopje"] = "Europe/Skopje";
    Timezone["Europe/Zagreb"] = "Europe/Zagreb";
    Timezone["Europe/Bratislava"] = "Europe/Bratislava";
    Timezone["Europe/Madrid"] = "Europe/Madrid";
    Timezone["Africa/Ceuta"] = "Africa/Ceuta";
    Timezone["Atlantic/Canary"] = "Atlantic/Canary";
    Timezone["Europe/Stockholm"] = "Europe/Stockholm";
    Timezone["Europe/Zurich"] = "Europe/Zurich";
    Timezone["Europe/Istanbul"] = "Europe/Istanbul";
    Timezone["Asia/Istanbul"] = "Asia/Istanbul";
    Timezone["Europe/Kiev"] = "Europe/Kiev";
    Timezone["Europe/Uzhgorod"] = "Europe/Uzhgorod";
    Timezone["Europe/Zaporozhye"] = "Europe/Zaporozhye";
    Timezone["Factory"] = "Factory";
    Timezone["EST"] = "EST";
    Timezone["MST"] = "MST";
    Timezone["HST"] = "HST";
    Timezone["EST5EDT"] = "EST5EDT";
    Timezone["CST6CDT"] = "CST6CDT";
    Timezone["MST7MDT"] = "MST7MDT";
    Timezone["PST8PDT"] = "PST8PDT";
    Timezone["America/New_York"] = "America/New_York";
    Timezone["America/Chicago"] = "America/Chicago";
    Timezone["America/North_Dakota/Center"] = "America/North_Dakota/Center";
    Timezone["America/North_Dakota/New_Salem"] = "America/North_Dakota/New_Salem";
    Timezone["America/North_Dakota/Beulah"] = "America/North_Dakota/Beulah";
    Timezone["America/Denver"] = "America/Denver";
    Timezone["America/Los_Angeles"] = "America/Los_Angeles";
    Timezone["America/Juneau"] = "America/Juneau";
    Timezone["America/Sitka"] = "America/Sitka";
    Timezone["America/Metlakatla"] = "America/Metlakatla";
    Timezone["America/Yakutat"] = "America/Yakutat";
    Timezone["America/Anchorage"] = "America/Anchorage";
    Timezone["America/Nome"] = "America/Nome";
    Timezone["America/Adak"] = "America/Adak";
    Timezone["Pacific/Honolulu"] = "Pacific/Honolulu";
    Timezone["America/Phoenix"] = "America/Phoenix";
    Timezone["America/Boise"] = "America/Boise";
    Timezone["America/Indiana/Indianapolis"] = "America/Indiana/Indianapolis";
    Timezone["America/Indiana/Marengo"] = "America/Indiana/Marengo";
    Timezone["America/Indiana/Vincennes"] = "America/Indiana/Vincennes";
    Timezone["America/Indiana/Tell_City"] = "America/Indiana/Tell_City";
    Timezone["America/Indiana/Petersburg"] = "America/Indiana/Petersburg";
    Timezone["America/Indiana/Knox"] = "America/Indiana/Knox";
    Timezone["America/Indiana/Winamac"] = "America/Indiana/Winamac";
    Timezone["America/Indiana/Vevay"] = "America/Indiana/Vevay";
    Timezone["America/Kentucky/Louisville"] = "America/Kentucky/Louisville";
    Timezone["America/Kentucky/Monticello"] = "America/Kentucky/Monticello";
    Timezone["America/Detroit"] = "America/Detroit";
    Timezone["America/Menominee"] = "America/Menominee";
    Timezone["America/St_Johns"] = "America/St_Johns";
    Timezone["America/Goose_Bay"] = "America/Goose_Bay";
    Timezone["America/Halifax"] = "America/Halifax";
    Timezone["America/Glace_Bay"] = "America/Glace_Bay";
    Timezone["America/Moncton"] = "America/Moncton";
    Timezone["America/Blanc-Sablon"] = "America/Blanc-Sablon";
    Timezone["America/Toronto"] = "America/Toronto";
    Timezone["America/Thunder_Bay"] = "America/Thunder_Bay";
    Timezone["America/Nipigon"] = "America/Nipigon";
    Timezone["America/Rainy_River"] = "America/Rainy_River";
    Timezone["America/Atikokan"] = "America/Atikokan";
    Timezone["America/Winnipeg"] = "America/Winnipeg";
    Timezone["America/Regina"] = "America/Regina";
    Timezone["America/Swift_Current"] = "America/Swift_Current";
    Timezone["America/Edmonton"] = "America/Edmonton";
    Timezone["America/Vancouver"] = "America/Vancouver";
    Timezone["America/Dawson_Creek"] = "America/Dawson_Creek";
    Timezone["America/Fort_Nelson"] = "America/Fort_Nelson";
    Timezone["America/Creston"] = "America/Creston";
    Timezone["America/Pangnirtung"] = "America/Pangnirtung";
    Timezone["America/Iqaluit"] = "America/Iqaluit";
    Timezone["America/Resolute"] = "America/Resolute";
    Timezone["America/Rankin_Inlet"] = "America/Rankin_Inlet";
    Timezone["America/Cambridge_Bay"] = "America/Cambridge_Bay";
    Timezone["America/Yellowknife"] = "America/Yellowknife";
    Timezone["America/Inuvik"] = "America/Inuvik";
    Timezone["America/Whitehorse"] = "America/Whitehorse";
    Timezone["America/Dawson"] = "America/Dawson";
    Timezone["America/Cancun"] = "America/Cancun";
    Timezone["America/Merida"] = "America/Merida";
    Timezone["America/Matamoros"] = "America/Matamoros";
    Timezone["America/Monterrey"] = "America/Monterrey";
    Timezone["America/Mexico_City"] = "America/Mexico_City";
    Timezone["America/Ojinaga"] = "America/Ojinaga";
    Timezone["America/Chihuahua"] = "America/Chihuahua";
    Timezone["America/Hermosillo"] = "America/Hermosillo";
    Timezone["America/Mazatlan"] = "America/Mazatlan";
    Timezone["America/Bahia_Banderas"] = "America/Bahia_Banderas";
    Timezone["America/Tijuana"] = "America/Tijuana";
    Timezone["America/Nassau"] = "America/Nassau";
    Timezone["America/Barbados"] = "America/Barbados";
    Timezone["America/Belize"] = "America/Belize";
    Timezone["Atlantic/Bermuda"] = "Atlantic/Bermuda";
    Timezone["America/Costa_Rica"] = "America/Costa_Rica";
    Timezone["America/Havana"] = "America/Havana";
    Timezone["America/Santo_Domingo"] = "America/Santo_Domingo";
    Timezone["America/El_Salvador"] = "America/El_Salvador";
    Timezone["America/Guatemala"] = "America/Guatemala";
    Timezone["America/Port-au-Prince"] = "America/Port-au-Prince";
    Timezone["America/Tegucigalpa"] = "America/Tegucigalpa";
    Timezone["America/Jamaica"] = "America/Jamaica";
    Timezone["America/Martinique"] = "America/Martinique";
    Timezone["America/Managua"] = "America/Managua";
    Timezone["America/Panama"] = "America/Panama";
    Timezone["America/Cayman"] = "America/Cayman";
    Timezone["America/Puerto_Rico"] = "America/Puerto_Rico";
    Timezone["America/Miquelon"] = "America/Miquelon";
    Timezone["America/Grand_Turk"] = "America/Grand_Turk";
    Timezone["US/Pacific-New"] = "US/Pacific-New";
    Timezone["America/Argentina/Buenos_Aires"] = "America/Argentina/Buenos_Aires";
    Timezone["America/Argentina/Cordoba"] = "America/Argentina/Cordoba";
    Timezone["America/Argentina/Salta"] = "America/Argentina/Salta";
    Timezone["America/Argentina/Tucuman"] = "America/Argentina/Tucuman";
    Timezone["America/Argentina/La_Rioja"] = "America/Argentina/La_Rioja";
    Timezone["America/Argentina/San_Juan"] = "America/Argentina/San_Juan";
    Timezone["America/Argentina/Jujuy"] = "America/Argentina/Jujuy";
    Timezone["America/Argentina/Catamarca"] = "America/Argentina/Catamarca";
    Timezone["America/Argentina/Mendoza"] = "America/Argentina/Mendoza";
    Timezone["America/Argentina/San_Luis"] = "America/Argentina/San_Luis";
    Timezone["America/Argentina/Rio_Gallegos"] = "America/Argentina/Rio_Gallegos";
    Timezone["America/Argentina/Ushuaia"] = "America/Argentina/Ushuaia";
    Timezone["America/Aruba"] = "America/Aruba";
    Timezone["America/La_Paz"] = "America/La_Paz";
    Timezone["America/Noronha"] = "America/Noronha";
    Timezone["America/Belem"] = "America/Belem";
    Timezone["America/Santarem"] = "America/Santarem";
    Timezone["America/Fortaleza"] = "America/Fortaleza";
    Timezone["America/Recife"] = "America/Recife";
    Timezone["America/Araguaina"] = "America/Araguaina";
    Timezone["America/Maceio"] = "America/Maceio";
    Timezone["America/Bahia"] = "America/Bahia";
    Timezone["America/Sao_Paulo"] = "America/Sao_Paulo";
    Timezone["America/Campo_Grande"] = "America/Campo_Grande";
    Timezone["America/Cuiaba"] = "America/Cuiaba";
    Timezone["America/Porto_Velho"] = "America/Porto_Velho";
    Timezone["America/Boa_Vista"] = "America/Boa_Vista";
    Timezone["America/Manaus"] = "America/Manaus";
    Timezone["America/Eirunepe"] = "America/Eirunepe";
    Timezone["America/Rio_Branco"] = "America/Rio_Branco";
    Timezone["America/Santiago"] = "America/Santiago";
    Timezone["America/Punta_Arenas"] = "America/Punta_Arenas";
    Timezone["Pacific/Easter"] = "Pacific/Easter";
    Timezone["Antarctica/Palmer"] = "Antarctica/Palmer";
    Timezone["America/Bogota"] = "America/Bogota";
    Timezone["America/Curacao"] = "America/Curacao";
    Timezone["America/Lower_Princes"] = "America/Lower_Princes";
    Timezone["America/Kralendijk"] = "America/Kralendijk";
    Timezone["America/Guayaquil"] = "America/Guayaquil";
    Timezone["Pacific/Galapagos"] = "Pacific/Galapagos";
    Timezone["Atlantic/Stanley"] = "Atlantic/Stanley";
    Timezone["America/Cayenne"] = "America/Cayenne";
    Timezone["America/Guyana"] = "America/Guyana";
    Timezone["America/Asuncion"] = "America/Asuncion";
    Timezone["America/Lima"] = "America/Lima";
    Timezone["Atlantic/South_Georgia"] = "Atlantic/South_Georgia";
    Timezone["America/Paramaribo"] = "America/Paramaribo";
    Timezone["America/Port_of_Spain"] = "America/Port_of_Spain";
    Timezone["America/Anguilla"] = "America/Anguilla";
    Timezone["America/Antigua"] = "America/Antigua";
    Timezone["America/Dominica"] = "America/Dominica";
    Timezone["America/Grenada"] = "America/Grenada";
    Timezone["America/Guadeloupe"] = "America/Guadeloupe";
    Timezone["America/Marigot"] = "America/Marigot";
    Timezone["America/Montserrat"] = "America/Montserrat";
    Timezone["America/St_Barthelemy"] = "America/St_Barthelemy";
    Timezone["America/St_Kitts"] = "America/St_Kitts";
    Timezone["America/St_Lucia"] = "America/St_Lucia";
    Timezone["America/St_Thomas"] = "America/St_Thomas";
    Timezone["America/St_Vincent"] = "America/St_Vincent";
    Timezone["America/Tortola"] = "America/Tortola";
    Timezone["America/Montevideo"] = "America/Montevideo";
    Timezone["America/Caracas"] = "America/Caracas";
})(Timezone || (Timezone = {}));
